import { Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { type FoundUser } from 'app/network/user';
import { getImageVariantUrl } from 'app/lib/image-variants';
import { Pressable, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconUser } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export const MemberRow = function MemberRow({
  user,
  selected,
  onToggle,
}: {
  user: FoundUser;
  selected: boolean;
  onToggle: (user: FoundUser) => void;
}) {
  const handlePress = () => onToggle(user);
  const firstName = user.profile?.firstName ?? '';
  const lastName = user.profile?.lastName ?? '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ');

  return (
    <Pressable onPress={handlePress}>
      <Row
        alignItems="center"
        gap="spacing.general.x4"
        paddingHorizontal="spacing.general.x8"
        paddingVertical="spacing.general.x2"
      >
        {user.profile?.picture ? (
          <PCImage
            aspectRatio={1}
            cachePolicy="memory-disk"
            height={44}
            recyclingKey={`${user.profile.picture}-group-row`}
            source={{ uri: getImageVariantUrl(user.profile.picture, 'mini') }}
            style={{ borderRadius: 22, opacity: selected ? 0.8 : 1 }}
          />
        ) : (
          <View
            style={{
              width: 44,
              height: 44,
              borderRadius: 22,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: theme.colors['surface.disabled'],
              opacity: selected ? 0.8 : 1,
            }}
          >
            <IconUser strokeWidth={ICON_STROKE_WIDTH} />
          </View>
        )}
        <Text flex={1} fontWeight="600" numberOfLines={1} style={{ opacity: selected ? 0.8 : 1 }}>
          {fullName}
        </Text>
        <View
          style={{
            width: 22,
            height: 22,
            borderRadius: theme.borderRadii['radius.sm'],
            borderWidth: 2,
            borderColor: selected ? theme.colors['surface.brand.default'] : theme.colors['surface.disabled'],
            backgroundColor: selected ? theme.colors['surface.brand.default'] : 'transparent',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {selected ? (
            <Text color="surface.default" fontSize={13} fontWeight="700">
              ✓
            </Text>
          ) : null}
        </View>
      </Row>
    </Pressable>
  );
};
